export default {
  BASE_URL: '/sys/fun',
  api: [
    {
      name: 'list',
      desc: '获取功能列表',
      method: 'GET',
      path: 'list'
    },
    {
      name: 'detail',
      desc: '获取功能详情',
      method: 'GET',
      path: 'info'
    },
    {
      name: 'insert',
      desc: '新增功能',
      method: 'POST',
      path: 'add'
    },
    {
      name: 'update',
      desc: '编辑功能',
      method: 'PUT',
      path: 'edit'
    },
    {
      name: 'toggleStatus',
      desc: '启用/禁用功能',
      method: 'PUT',
      path: '/isEnable/update'
    },
    {
      name: 'delete',
      desc: '删除功能',
      method: 'PUT',
      path: 'delete'
    },
    {
      name: 'checkName',
      desc: '校验路由名称/功能编码是否重复',
      method: 'GET',
      path: 'checkName'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/system/function/index.js